export class QuickSearch{
    label:string;
    search: Search;
}
export class Search{
    title:string;
    service:string;
    column:Array<Column>;
    toSearch:string;
}

export class Column{
    name:string;
    nickname:string;
    visible:boolean;
}


// WEBPACK FOOTER //
// ./src/app/class/search.ts